import { MenuOutlined } from "@ant-design/icons";
import { AntdBreadcrumb, Drawer, Space } from "@pankod/refine-antd";
import { MyFormProps } from "components/forms";
import { NewTemplateForm } from "components/forms/frm_new_template";
import { ITemplate } from "interfaces";

interface DrawerAddTempalteProps extends MyFormProps {
  title: string;
  open: boolean;
  onFinish: (newTemplate: ITemplate) => void;
  onClose: () => void;
}

export const DrawerAddTemplate = ({
  title,
  open,
  onFinish,
  onClose,
  formProps,
  queryResult,
}: DrawerAddTempalteProps) => (
  <Drawer
    placement="right"
    onClose={onClose}
    visible={open}
    width={"100%"}
    style={{ maxWidth: "575px" }}
  >
    <Space direction="vertical" style={{ padding: "0 18px" }}>
      <AntdBreadcrumb>
        <AntdBreadcrumb.Item>
          <MenuOutlined style={{ fontSize: "12px" }} />
        </AntdBreadcrumb.Item>

        <AntdBreadcrumb.Item>Engajamento</AntdBreadcrumb.Item>

        <AntdBreadcrumb.Item>
          Parametrizar Disparos x Templates
        </AntdBreadcrumb.Item>

        <AntdBreadcrumb.Item>{title}</AntdBreadcrumb.Item>
      </AntdBreadcrumb>

      <NewTemplateForm
        formProps={{ ...formProps, onFinish }}
        queryResult={queryResult}
        title={title}
      />
    </Space>
  </Drawer>
);
